const gigCategories = [
	{
		path: '/jobs/gig-categories/list',
		name: 'jobs-gig-categories-list',
		component: () => import('@/views/jobs/gig-categories/list.vue'),
		meta: { layout: 'content', module: 'MGJ,gigs' },
	},
]

export default gigCategories
